<div class="flex flex-row items-center justify-between">
  <v4-widget-image-caption class="overflow-hidden">
    <div class="image-caption_image relative">
      <img
        class="w-20 h-14 rounded-[10px]"
        hostPlaceholder
        [delaySrc]="houseInfo?.thumbnail"
        src="/assets/status/placeholder.png" />
      <img
        [src]="(houseInfo?.thirdparty | thirdparty)?.icon_color_bg"
        class="absolute top-1 left-1 w-[18px] h-[18px] rounded-full" />
      @if (houseInfo?.inventory > 1) {
        <span class="count absolute top-1 right-1"> x {{ houseInfo?.inventory }} </span>
      }
    </div>
    <div class="image-caption_caption overflow-hidden">
      @if (houseInfo.linkUrl) {
        <a [href]="houseInfo.linkUrl" target="_blank">
          <div class="mb-2 text-m text-ellipsis">{{ houseInfo?.title }}</div>
        </a>
      } @else {
        <div class="mb-2 text-m text-ellipsis">{{ houseInfo?.title }}</div>
      }
      <div class="text-s ellipsis-line-2">
        <span>{{ houseInfo?.username }}</span>
        <span>-{{ houseInfo?.origin_house_id?.split("-")?.[0] }}</span>
      </div>
    </div>
  </v4-widget-image-caption>
  <ng-content select=".house-card_btns"></ng-content>
</div>
